//CART ACTIONS

export const UPDATE_SOMETHING = "UPDATE_SOMETHING";
export const ACTN_REFRESH = "ACTN_REFRESH";
export const ACTN_IS_PROCESSING = "ACTN_IS_PROCESSING";

export const PUSH_ITEM = "PUSH_ITEM";
export const PUSH_ITEM_REMOTELY = "PUSH_ITEM_REMOTELY";
export const PUSH_ITEM_REMOTELY_FAILURE = "PUSH_ITEM_REMOTELY_FAILURE";
export const PUSH_ITEM_REMOTELY_SUCCESS = "PUSH_ITEM_REMOTELY_SUCCESS";

export const CART_IS_LOADING = "CART_IS_LOADING";

export const GET_CART = "GET_CART";
export const GET_CART_FAIL = "GET_CART_FAIL";
export const GET_CART_SUCCESS = "GET_CART_SUCCESS";

export const ADD_CART_TO_CLOSED = "ADD_CART_TO_CLOSED";

export const UPDATE_UI = "UPDATE_UI";
export const CARS_IS_LOADING = "CARS_IS_LOADING";

export const UPDATE_UI_SUCCESS = "UPDATE_UI_SUCCESS";
export const GET_CARS = "GET_CARS";
export const GET_CARS_FAIL = "GET_CARS_FAIL";
export const GET_CARS_SUCCESS = "GET_CARS_SUCCESS";

export const GET_CARDETAILS_SUCCESS = "GET_CARDETAILS_SUCCESS";
export const SAVE_SELECTEDCAR = "SAVE_SELECTEDCAR";
export const SAVE_SELECTEDDIAMETERS = "SAVE_SELECTEDDIAMETERS";

export const GET_SHOP_SUCCESS = "GET_SHOP";
export const GET_SHOP_FAIL = "GET_SHOP_FAIL";
export const CLEAR_SHOP_SUCCESS = "CLEAR_SHOP_SUCCESS";
export const GET_SHOPS = "GET_SHOPS";
export const GET_SHOPS_FAIL = "GET_SHOPS_FAIL";
export const GET_SHOPS_SUCCESS = "GET_SHOPS_SUCCESS";
export const GET_GEOCODER_SUCCESS = "GET_GEOCODER_SUCCESS";
export const GEOCODER_IS_WAITING = "GEOCODER_IS_WAITING";

export const SHOPS_IS_LOADING = "SHOPS_IS_LOADING";

export const GET_VISTOR_FAIL = "GET_VISTOR_FAIL";
export const GET_VISITOR_SUCCESS = "GET_VISITOR_SUCCESS";
export const PUSH_VISITOR = "PUSH_VISITOR";

export const VISITOR_IS_LOADING = "VISITOR_IS_LOADING";
